export default __webpack_public_path__ + "static/media/R870_2.3d75f103.png";